<template>
  <div>
    <el-form v-loading="loading" label-width="80px" :model="data">
      <el-form-item label="名称">
        <el-input v-model="data.name"></el-input>
      </el-form-item>
      <el-form-item label="活动区域">
        <el-input v-model="data.region"></el-input>
      </el-form-item>
      <el-form-item label="活动形式">
        <el-input v-model="data.type"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { useRoute } from "vue-router";
// import axios from 'axios'
import { getGoodDetails } from "../http/api";
import { onMounted, reactive, ref } from "vue";
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const route = useRoute();
    let loading = ref(false);
    let data = reactive({
        info:{},
        isEmt:false
    })

    onMounted(() => {
      getGoodDetails({ id: props.id || route.query.id }).then((res) => {
        data.info = res
        loading.value = true;
      });
    });

    return {
      loading,
      data
    };
  },
};
</script>